module.exports = "/fonts/fa-brands-400.ttf?13685372945d816a2b474fc082fd9aaa";